import * as types from './actionTypes';
import {FUNDING_APP_BASE_URL} from '../constants/global';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function accountRepDataURL() {
  const url = `${FUNDING_APP_BASE_URL()}account_reps`;
  return url;
}

export function receiveAccountRepData(json) {
  return {type: types.RECEIVE_ACCOUNT_REP_DATA, accountRepData: json };
}

export function fetchAccountRepData() {
  return dispatch => {
    return authenticatedFetch(accountRepDataURL(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) return;
      return response.json();
    })
    .then(json => {
      if (json) dispatch(receiveAccountRepData(json));
    });
  };
}
